import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsFilledSuccessCircle = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM14.707 8.20711C15.0975 7.81659 15.0975 7.18342 14.707 6.79289C14.3165 6.40237 13.6833 6.40237 13.2928 6.79289L7.99997 12.0857L6.70711 10.7928C6.31658 10.4023 5.68342 10.4023 5.29289 10.7928C4.90237 11.1834 4.90237 11.8165 5.29289 12.2071L7.29286 14.207C7.68338 14.5975 8.31655 14.5975 8.70707 14.207L14.707 8.20711Z"
          fill="inherit"
        />
      </svg>
    );
  }
);

export default PdsFilledSuccessCircle;
